/* 🤖 this file was generated by svg-to-ts */
export const matIconWoman2: {
  name: 'woman-2';
  data: string;
} = {
  name: 'woman-2',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13.94 8.31C13.62 7.52 12.85 7 12 7s-1.62.52-1.94 1.31L7 16h3.5v6h3v-6H17l-3.06-7.69z"/><circle cx="12" cy="4" r="2"/></svg>`
};
